import { Suspense } from "react";

const Loadable = (Component) => {
  const WrappedComponent = (props) => (
    <Suspense
      fallback={
        <div className="d-flex justify-content-center align-items-center vh-100">
          {/* <div className="spinner-border" role="status">
          </div> */}
          <div className="boxLoad"></div>
        </div>
      }
    >
      <Component {...props} />
    </Suspense>
  );

  WrappedComponent.displayName = `Loadable(${
    Component.displayName || Component.name || "Component"
  })`;

  return WrappedComponent;
};

export default Loadable;
